'use client'
import Link from 'next/link'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { useEffect, useState } from 'react'
import { useLanguage } from '@/contexts/LanguageContext'
import StoreProductCard from './StoreProductCard'
import { useTranslations } from 'next-intl'

export default function Today_Offers_Store({
  Products,
  title = '',
  desktopRows = 2,
}: {
  Products: any
  title: string
  desktopRows?: 1 | 2
}) {
  const { language } = useLanguage()
  const isRTL = language === 'ar'
  const [isSwiperMounted, setIsSwiperMounted] = useState(false)
  const t = useTranslations('store')

  useEffect(() => {
    setIsSwiperMounted(true)
  }, [])

  const desktopVisibleProducts =
    desktopRows === 1
      ? Products?.products?.slice(0, 4)
      : Products?.products?.slice(0, 8)

  return (
    <div className='sm:py-2   w-full max-w-[1440px] flex flex-col gap-5'>
      <div className='w-full flex justify-between items-center px-2 '>
        <h2 className='text-[#D1D3D4] text-[24px] md:text-[40px] font-bold '>
          {title}
        </h2>

        <Link
          href={`/store/products-by-category/${Products?.id || ''}`}
          className='text-[#D1D3D4] text-[16px] md:text-[20px] flex justify-center items-center gap-1 md:gap-3 pe-2 sm:pe-0 '
        >
          <span className='underline    '>{t('viewAll')}</span>
          <svg
            width='7'
            height='13'
            viewBox='0 0 7 13'
            className={`mt-1 ${!isRTL ? 'rotate-180' : ''}`}
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
REPLACE
            <path
              d='M6.5 0.5L0.5 6.5L6.5 12.5'
              stroke='#d9ac4f'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </Link>
      </div>

      {/* Desktop Grid */}
      <div className='hidden md:grid grid-cols-1 lg:grid-cols-4  md:gap-x-4 md:gap-y-6 md:grid-cols-2'>
        {desktopVisibleProducts?.map((el: any) => {
          return (
            <div className='col-span-1' key={el.id}>
              <StoreProductCard data={el} />
            </div>
          )
        })}
      </div>

      {/* Mobile Slider */}
      <div className='block md:hidden w-full me-[30px] flex shrink-0 overflow-x-hidden'>
        <Swiper
          key={`today-offers-swiper-${isRTL ? 'rtl' : 'ltr'}`}
          slidesPerView={1.9}
          spaceBetween={12}
          dir={isRTL ? 'rtl' : 'ltr'}
          resistanceRatio={0}
          watchOverflow={true}
          centeredSlides={false}
          observer={true}
          observeParents={true}
          className={`w-full !px-2 !py-2 transition-opacity duration-150 ${isSwiperMounted ? 'opacity-100' : 'opacity-0'}`}
        >
          {Products?.products?.map((el: any) => (
            <SwiperSlide key={el.id} className='!h-auto'>
              <StoreProductCard data={el} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}